import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/shareholder/FullView.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
